import { useEffect } from "react";

export function useButtonTableDynamicStyles(
  colorViewBtn,
  colorEditBtn,
  colorDeleteBtn,
  iconViewBtn,
  iconEditBtn,
  iconDeleteBtn,
  hoverViewBtn,
  hoverEditBtn,
  hoverDeleteBtn,
  colorCreateBtn,
  hoverCreateBtn,
  textSearchBtn,
  textResetBtn,
  iconSearchBtn,
  iconResetBtn,
  hoverSearchBtn,
  hoverResetBtn
) {
  useEffect(() => {
    document.documentElement.style.setProperty("--colorViewBtn", colorViewBtn);

    document.documentElement.style.setProperty("--colorEditBtn", colorEditBtn);
    document.documentElement.style.setProperty(
      "--colorDeleteBtn",
      colorDeleteBtn
    );
    document.documentElement.style.setProperty("--iconViewBtn", iconViewBtn);
    document.documentElement.style.setProperty("--iconEditBtn", iconEditBtn);
    document.documentElement.style.setProperty(
      "--iconDeleteBtn",
      iconDeleteBtn
    );
    document.documentElement.style.setProperty("--hoverViewBtn", hoverViewBtn);
    document.documentElement.style.setProperty("--hoverEditBtn", hoverEditBtn);
    document.documentElement.style.setProperty(
      "--hoverDeleteBtn",
      hoverDeleteBtn
    );
    document.documentElement.style.setProperty(
      "--colorCreateBtn",
      colorCreateBtn
    );
    document.documentElement.style.setProperty(
      "--hoverCreateBtn",
      hoverCreateBtn
    );
    // testt
    document.documentElement.style.setProperty(
      "--textSearchBtn",
      textSearchBtn
    );
    document.documentElement.style.setProperty("--textResetBtn", textResetBtn);
    document.documentElement.style.setProperty(
      "--iconSearchBtn",
      iconSearchBtn
    );
    document.documentElement.style.setProperty("--iconResetBtn", iconResetBtn);
    document.documentElement.style.setProperty(
      "--hoverSearchBtn",
      hoverSearchBtn
    );
    document.documentElement.style.setProperty(
      "--hoverResetBtn",
      hoverResetBtn
    );
  }, [
    colorViewBtn,
    colorEditBtn,
    colorDeleteBtn,
    iconViewBtn,
    iconEditBtn,
    iconDeleteBtn,
    colorCreateBtn,
    hoverCreateBtn,
    textResetBtn,
    textSearchBtn,
    hoverDeleteBtn,
    hoverEditBtn,
    hoverResetBtn,
    hoverSearchBtn,
    hoverViewBtn,
    iconResetBtn,
    iconSearchBtn
  ]);
}
